import PropTypes from 'prop-types';

export default function Tabs({ active, setActive }) {
    const tabs = [
        { key: 'process', label: 'Process & Culture' },
        { key: 'customer', label: 'Customer' },
        { key: 'growth', label: 'Growth & Technology' },
        { key: 'financial', label: 'Financial Commitments' }
    ];

    return (
        <div className="tabs" role="tablist" aria-label="KPI categories">
            {tabs.map((t) => (
                <button
                    key={t.key}
                    type="button"
                    role="tab"
                    aria-selected={active === t.key}
                    className={`tab ${active === t.key ? 'active' : ''}`}
                    onClick={() => setActive(t.key)}>
                    {t.label}
                </button>
            ))}
        </div>
    );
}

Tabs.propTypes = {
    active: PropTypes.string.isRequired,
    setActive: PropTypes.func.isRequired
};
